module.exports = __webpack_public_path__ + "static/media/compra-segura.8202627e.png";